import { Component, OnInit, Output, EventEmitter, HostListener, ViewChild, ElementRef, Input, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MessageBoxService } from '../../messagebox/services/messagebox.service';
import { MessageBoxButtons, MessageBoxIcon } from '../../messagebox/messagebox.model';
import { delay } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-keyword-search',
    templateUrl: './keyword-search.component.html',
    styleUrls: ['./keyword-search.component.scss']
})
export class KeywordSearchComponent implements OnInit, OnDestroy {
    @ViewChild('keywordInput')
    keywordInput: ElementRef;

    @Input()
    currentSiteChangedEvent = new EventEmitter<void>();

    @Input()
    dashboardName = 'Orders';

    @Output()
    keywords = new EventEmitter<string>();

    searchForm: UntypedFormGroup;
    subscriptions = new Subscription();

    isSubmitted = false;

    constructor(private readonly formBuilder: UntypedFormBuilder, private readonly messageBoxService: MessageBoxService) {}

    ngOnInit(): void {
        this.searchForm = this.formBuilder.group({
            keyword: []
        });
        this.subscriptions.add(
            this.currentSiteChangedEvent.subscribe(_ => {
                this.clear();
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    submit() {
        if (this.searchForm.controls.keyword.value?.length > 0 && this.searchForm.controls.keyword.value?.length < 3) {
            this.keywordInput.nativeElement.blur();
            const title = 'More characters are required';
            const message = 'Please enter three or more characters to search.';
            this.messageBoxService
                .showMessageBox({
                    title,
                    message,
                    information: null,
                    icon: MessageBoxIcon.Information,
                    buttons: MessageBoxButtons.Ok
                })
                .pipe(delay(100))
                .subscribe(() => {
                    this.keywordInput.nativeElement.focus();
                });
            return;
        }
        this.keywords.emit(this.searchForm.controls.keyword.value);
        if (this.searchForm.controls.keyword.value) {
            this.isSubmitted = true;
        } else {
            this.isSubmitted = false;
        }
    }

    clear() {
        this.searchForm.reset();
        this.submit();
    }

    @HostListener('keyup.enter')
    onEnterKey() {
        this.submit();
    }

    @HostListener('keyup.escape')
    onEscapeKey() {
        this.clear();
    }
}
